<template>
	<v-card v-if="examination" class="bowel-cleanse-forms">
    <v-layout>
      <v-flex xs8>
        <v-container grid-list-lg class="pa-0">
        <v-layout>
          <v-flex xs4>
            <inspection-instrument-input
              :data="examination.examination.inspection_instrumentID"
              hide-details
              @change="$emit('change', { field: 'inspection_instrumentID', event: $event } )"
            ></inspection-instrument-input>
            <wash-instrument-input
              :data="examination.examination.wash_instrumentID"
              hide-details
              @change="$emit('change', { field: 'wash_instrumentID', event: $event } )"
            ></wash-instrument-input>
          </v-flex>
          <v-flex xs4>
             <sedative-input-group
              :examinationID="examinationID"
              :sedatives="sedatives"
              :sedativesList="examination.sedatives"
              :sedativeOther="examination.examination.sedativeOther"
              @change="$emit('change', { field: 'sedativeOther', event: $event.event } )"
              hide-details
            ></sedative-input-group>
          </v-flex>  
          <v-flex xs4>
            <incomplete-due-to-input
              :data="examination.examination.incompleteDue"
              :examinationTypeID="examination.examination.examination_typeID"
              hide-details
              @change="$emit('change', { field: 'incompleteDue', event: $event } )"
            ></incomplete-due-to-input>
          </v-flex>
        </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs4>
        <div class="label-text">Additional Remarks</div>
        <v-textarea
          no-resize
          outline
          height="133px"
          row-height="20px"
          v-model="additionalRemarksValue"
          class="additional-remarks"
          @change="$emit('change', { field: 'additionalRemarks', event: $event } )"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import forms from '@/utils/forms'
  import SedativeInputGroup  from '@/components/bowelCleanseForms/SedativeInputGroup.vue'
  import InspectionInstrumentInput from '@/components/bowelCleanseForms/InspectionInstrumentInput.vue'
  import WashInstrumentInput from '@/components/bowelCleanseForms/WashInstrumentInput.vue'
  import CleanScaleInput from '@/components/bowelCleanseForms/CleanScaleInput.vue'
  import InsertionLevelInput from '@/components/bowelCleanseForms/InsertionLevelInput.vue'
  import IncompleteDueToInput from '@/components/bowelCleanseForms/IncompleteDueToInput.vue'

	export default {
		name: 'GastroReportBowelCleanseForms',

    components: {
      SedativeInputGroup,
      InspectionInstrumentInput,
      WashInstrumentInput,
      CleanScaleInput,
      InsertionLevelInput,
      IncompleteDueToInput,
    },

		props: {
      examination: {
        type: Object,
        required: true
      },

      sedatives: {
        type: Array,
      }
    },

		data () {
			return {
        timeList: [
          'insertionTime',
          'proximalColonWithTime',
          'withdrawTime',
          'totalExamTime'
        ],
        EXAMINATION_TYPE_OF_GASTROSCOPY: 1
			}
		},

		computed: {
      examinationID () {
        return this.examination.examination['id']
      },
      additionalRemarksValue : {
        get () { return this.examination.examination.additionalRemarks },
        set (val) { this.examination.examination.additionalRemarks = val }
      },
		}
	}
</script>

<style lang="scss">
  @import '@/styles/components/bowelCleanseForms.scss';
</style>